import { z } from "zod";
import { isValidPhoneNumber } from "react-phone-number-input";
import { eventTypeTypeValues } from "@ac-expo/api-types";
import { placeSchema } from "./event-place.schema";
import { defaultCreateEventValues } from "./create-event.schema";
import { toDatabaseFormat } from "@ac-expo/utils";

const dateSchema = z
  .date()
  .refine((date) => !isNaN(new Date(date).getTime()), "Date invalide");

const timeSchema = z.object({
  start: z.string(),
  end: z.string(),
  day: z.string(),
});

const dateRangeSchema = z
  .object({
    from: dateSchema,
    to: dateSchema,
    times: z.array(timeSchema),
  })
  .refine(
    (data) => {
      const fromDate = new Date(data.from);
      const toDate = new Date(data.to);
      return fromDate <= toDate;
    },
    {
      message: "La date de début doit être avant la date de fin",
      path: ["to"],
    }
  );

export const createEventAsVisitorSchema = z.object({
  name: z.string().min(1, "Le nom de l'événement est requis"),
  type: z.enum([...eventTypeTypeValues, ""]),
  place: placeSchema,
  dates: dateRangeSchema,
  organiserName: z.string().optional(),
  organiserEmail: z
    .string()
    .email("Email invalide")
    .optional()
    .or(z.literal("")),
  organiserPhone: z
    .string()
    .optional()
    .refine((phone) => !phone || isValidPhoneNumber(phone, "FR"), {
      message: "Téléphone invalide",
    }),
  websiteUrl: z.string().url().optional().or(z.literal("")),
  entry: z
    .enum(["free", "paid"], {
      required_error: "Veuillez sélectionner un type d'entrée",
    })
    .default("free"),
  venue: z
    .object({
      indoor: z.boolean(),
      outdoor: z.boolean(),
    })
    .refine((data) => data.indoor || data.outdoor, {
      message: "Au moins un type de lieu doit être sélectionné",
    }),
});

export type AddEventAsVisitorForm = z.infer<typeof createEventAsVisitorSchema>;

export type PlaceSchema = z.infer<typeof placeSchema>;

export const defaultCreateEventAsVisitorValues = {
  ...defaultCreateEventValues,
  dates: {
    from: new Date(),
    to: new Date(),
    times: [
      {
        start: "8:00",
        end: "18:00",
        day: toDatabaseFormat(new Date()),
      },
    ],
  },
};
